import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-side-menu',
  templateUrl: './menu-item-list.component.html',
  styleUrls: ['./menu-item-list.component.scss']
})
export class SideMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Dashboard/menus/main-menu/sidebar/menu-item-list.component.ts